import { tracking } from '@iwoca/frontend-tracking-library';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { useTutorials } from './useTutorials.hook';

type TTour = {
  name: string;
  description: string;
  onClick: () => void;
};

export const usePortalTours = () => {
  const { triggerNavigationTour } = useTutorials();

  const handleNavigationTourClick = () => {
    trackEvent('Navigation');
    triggerNavigationTour();
  };

  const trackEvent = (tour: string) => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Start tour',
      category: tour,
    });
  };

  const getTourData = (): TTour[] => [
    {
      name: 'Navigation',
      description:
        'Learn how to move around the Portal, use helpful tools, and create new applications.',
      onClick: () => handleNavigationTourClick(),
    },
    {
      name: 'Dashboard',
      description:
        'Discover how to search, filter, and manage applications efficiently from your dashboard.',
      onClick: () => console.log('TODO: Implement next'),
    },
    {
      name: 'Calculator',
      description:
        'Quickly calculate and share repayment schedules tailored to your clients.',
      onClick: () => console.log('TODO: Implement next'),
    },
  ];

  return {
    tourData: getTourData(),
  };
};
